import { CircleHelp, KeyRound, Moon, ShieldCheck, Sun } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "../lib/utils";
import { ehRegula } from "../lib/tenant";
import { useContext } from "react";
import { EmpresaAtivaCtx } from "../hooks/empresaAtivaContext";

/**
 * Os ícones da direita no pé do menu lateral: Ajuda, Trocar senha, Tema.
 *
 * A Ajuda entrou em 19/09/2026 com mock aprovado pelo dono (um ícone a mais,
 * antes da chave; nada mais muda). Ela é LINK, não botão: abre a busca dos
 * manuais numa aba nova, e quem está no meio de um formulário não perde nada.
 * Os manuais são páginas soltas publicadas junto com o painel, em /manuais/
 * (ver docs/manuais/README.md) — não passam pelo roteador do React.
 *
 * 🔐 14/10/2026 (mock 11 do pacote 2, aprovado): o escudo da "Verificação em duas etapas" aparece SÓ quando a
 * empresa ativa é da Regula, ao lado da chave da senha. Nas outras empresas o pé fica exatamente como era.
 */
export const ENDERECO_DA_AJUDA = "/manuais/buscar.html";

const ICONE = "p-1.5 rounded-md hover:bg-white/10 text-white/70 hover:text-white transition-colors";

export function BotoesDoPe({
  empilhado,
  tema,
  onTrocarSenha,
  onTrocarTema,
}: {
  empilhado: boolean;
  tema: string;
  onTrocarSenha: () => void;
  onTrocarTema: () => void;
}) {
  const daRegula = ehRegula(useContext(EmpresaAtivaCtx)?.ativa ?? null); // direto do contexto: os testes que dublam o hook não derrubam o pé
  return (
    <div className={cn("flex items-center gap-1", empilhado && "flex-col")}>
      <a
        href={ENDERECO_DA_AJUDA}
        target="_blank"
        rel="noopener noreferrer"
        className={ICONE}
        title="Ajuda: manuais do painel"
        aria-label="Ajuda: manuais do painel"
      >
        <CircleHelp className="h-4 w-4" />
      </a>
      <button onClick={onTrocarSenha} className={ICONE} title="Trocar minha senha" aria-label="Trocar minha senha">
        <KeyRound className="h-4 w-4" />
      </button>
      {daRegula && (
        <Link to="/minha-conta/duas-etapas" className={ICONE} title="Verificação em duas etapas" aria-label="Verificação em duas etapas">
          <ShieldCheck className="h-4 w-4" />
        </Link>
      )}
      <button
        onClick={onTrocarTema}
        className={ICONE}
        title={tema === "dark" ? "Modo claro" : "Modo escuro"}
        aria-label="Alternar tema"
      >
        {tema === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>
    </div>
  );
}
